import { render, staticRenderFns } from "./CheckoutOrder.vue?vue&type=template&id=1945bef6&scoped=true&"
import script from "./CheckoutOrder.vue?vue&type=script&lang=js&"
export * from "./CheckoutOrder.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutOrder.vue?vue&type=style&index=0&id=1945bef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945bef6",
  null
  
)

export default component.exports